export const maxWidth = {
  xs: `max-width: 18rem`,
  sm: `max-width: 24rem`,
  md: `max-width: 28rem`,
  lg: `max-width: 32rem`,
  xl: `max-width: 36rem`,
  twox: `max-width: 42rem`,
  threex: `max-width: 48rem`,
  fourx: `max-width: 56rem`,
  fivex: `max-width: 64rem`,
  sixx: `max-width: 72rem`,
  sevenx: `max-width: 80rem;`,
};

export const shadow = {
  button: "0 20px 30px rgba(0, 0, 0, 0.1)",
  blue: "0 20px 30px rgba(46,191,253, 0.1)",
  blue_mo: "0 20px 30px rgba(46,191,253, 0.2)",
  image: "0 15px 25px rgba(0, 0, 0, 0.1)",
  suggestion: "0 -5px 30px rgba(0,0,0,0.2)",
  footer: "0 -3px 26px rgba(0,0,0,0.5)",
  feature: {
    big: {
      default: "0 40px 40px rgba(0, 0, 0, 0.2)",
      hover: "0 50px 50px rgba(0, 0, 0, 0.1)",
    },
    small: {
      default: "0 15px 25px rgba(0, 0, 0, 0.2)",
      hover: "0 40px 45px rgba(0, 0, 0, 0.1)",
    },
  },
  text: {
    small: "0 5px 10px rgba(0, 0, 0, 0.25)",
    big: "0 15px 20px rgba(0, 0, 0, 0.13)",
  },
};

// export const gradient = {
//   leftToRight: `linear-gradient(-45deg, ${colors.background.light} 0%, ${colors.background.dark} 100%)`,
//   rightToLeft: `linear-gradient(45deg, ${colors.background.light} 0%, ${colors.background.dark} 100%)`,
//   red: `linear-gradient(45deg, ${colors.red.light} 0%, ${colors.red.dark} 100%)`,
// }

export const transition = {
  easeInOutCubic: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  easeOutBack: "cubic-bezier(0.175, 0.885, 0.32, 1.275)",
  duration: "0.4s",
};

export const devices = {
  xs: `(min-width: 400px)`,
  sm: `(min-width: 640px)`,
  md: `(min-width: 768px)`,
  lg: `(min-width: 1024px)`,
  xl: `(min-width: 1170px)`,
};

export const theme = {
  shadow,
  devices,
  maxWidth,
  layout: {
    article: "46rem",
    base: "70rem",
    big: "83.33333rem",
  },
  borderRadius: {
    default: "0.4rem",
    round: "100rem",
  },
  transitions: {
    default: {
      duration: transition.duration,
      timing: transition.easeInOutCubic,
      transition: `all ${transition.duration} ${transition.easeInOutCubic}`,
    },
    boom: {
      duration: transition.duration,
      timing: transition.easeOutBack,
      transition: `all ${transition.duration} ${transition.easeOutBack}`,
    },
    headroom: {
      transition: "all 0.25s ease-in-out",
    },
  },
};

export default theme;
